import React from "react";

import SideNav from "./SideNav";
import TopBar from "./TopBar";
// import Header from "./Header";
// import Footer from "./Footer";

const Nav = ({ msalInstance }) => {
  return (
    <>
      {/* <Header /> */}
      <TopBar
        preferredName={
          msalInstance.getActiveAccount()?.idTokenClaims?.gmPreferredName
        }
      />
      <SideNav />
      {/* <Footer /> */}
    </>
  );
};

export default Nav;
